import React, { Component } from 'react'
import { Collapse, Button, CardBody, Card, CardHeader } from 'reactstrap'
import LoaderSpinner from '../views/Widgets/LoaderSpinner'
import GNAddressFormat from '../helpers/GNAddressFormat'
import parseDate from '../helpers/parseDate'

export default class DeleteRequestCard extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.onDeny = this.onDeny.bind(this)
    this.state = { collapse: false, isDenying: false, isApproving: false }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.finishedWithError) {
      this.setState({ isDenying: false, isApproving: false })
    }
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse }, () => {
      if (this.props.onOpen && this.state.collapse) {
        this.props.onOpen()
      }
    })
  }

  onClose() {
    this.setState({ isClosing: true })
    this.props.onClose()
  }

  onDelete() {
    this.setState({ isDeleting: true })
    this.props.onDelete()
  }

  onDeny() {
    this.setState({ isDenying: true })
    this.props.onDeny()
  }

  render() {
    const { data } = this.props
    return (
      <div>
        <CardHeader
          onClick={this.toggle}
          style={{ marginBottom: '1rem', cursor: 'pointer' }}
        >
          {this.props.title}
        </CardHeader>
        <Collapse isOpen={this.state.collapse}>
          <Card>
            <CardBody>
              <div style={{ whiteSpace: 'pre-line' }}>
                Submitted On: {parseDate(data.createdAt)} <br />
                Business ID: {data.business.id} <br />
                BusinessPage URL:{' '}
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`${APP_BASE_URL}/place/${data.business.slug}`}
                >{`${APP_BASE_URL}/place/${data.business.slug}`}</a>
                <br />
                Business Address:{' '}
                {GNAddressFormat(data.business.location.address)} <br />
                Reason: {data.reason}
                <div className="form-actions" style={{ marginTop: 10 }}>
                  <Button
                    onClick={this.onClose}
                    type="submit"
                    color="primary"
                    disabled={this.state.isClosing || this.state.isDeleting || this.state.isDenying}
                    style={{marginRight: '5px'}}
                  >
                    {this.state.isClosing && (
                      <i
                        className="fa fa-circle-o-notch fa-spin"
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Close
                  </Button>
                  <Button
                    onClick={this.onDelete}
                    type="submit"
                    color="primary"
                    disabled={this.state.isClosing || this.state.isDeleting || this.state.isDenying}
                    style={{marginRight: '5px'}}
                  >
                    {this.state.isDeleting && (
                      <i
                        className="fa fa-circle-o-notch fa-spin"
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Delete
                  </Button>
                  <Button
                    color="danger"
                    onClick={this.onDeny}
                    disabled={this.state.isClosing || this.state.isDeleting || this.state.isDenying}
                  >
                    {this.state.isDenying && (
                      <i
                        className="fa fa-circle-o-notch fa-spin"
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Deny
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
        </Collapse>
      </div>
    )
  }
}

DeleteRequestCard.defaultProps = {
  title: 'New Delete Request'
}



// WEBPACK FOOTER //
// ./src/components/DeleteRequestCard.js